module.exports = __webpack_public_path__ + "img/eazibg.f2733cd3.svg";